import { ScoreHealthRangeBreakpoint } from '../../..';

export const DEBT_RATE_SCORE_HEALTH_RANGE_BREAKPOINTS: ScoreHealthRangeBreakpoint[] = [
  { category: 'atypicallyLow', min: 0, max: 0.05, id: 'atypicallyLow_Dr' },
  { category: 'low', min: 0.05, max: 0.15, id: 'low_Dr' },
  { category: 'typical', min: 0.15, max: 0.3, id: 'typical_Dr' },
  { category: 'high', min: 0.3, max: 0.45, id: 'high_Dr' },
  { category: 'atypicallyHigh', min: 0.45, max: 1, id: 'atypicallyHigh_Dr' },
];
